<template>
    <div class="header-challenge-leaderboard">
        <h1 class="header-challenge-leaderboard__heading">En İyiler</h1>
        <p class="header-challenge-leaderboard__week">Hafta #{{ week }}</p>
    </div>
</template>
<script>
    export default {
        props: {
            week: {
                type: Number,
                default: 1,
            }
        }
    };
</script>
<style scoped src="@/css/components/header-challenge-leaderboard.css"></style>